import { render, staticRenderFns } from "./PaymentsForms.vue?vue&type=template&id=3779b3ec&scoped=true&lang=pug&"
import script from "./PaymentsForms.vue?vue&type=script&lang=ts&"
export * from "./PaymentsForms.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsForms.vue?vue&type=style&index=0&id=3779b3ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779b3ec",
  null
  
)

export default component.exports